import PropTypes from 'prop-types'
import cn from '../cn'

function ErrorScreen({ authenticationError, permissionError }) {
  return (
    <div
      className={cn(
        'bg-gray-200 h-screen flex text-gray-800 text-center content-center items-center',
        'fixed left-0 top-0 right-0 bottom-0',
      )}
    >
      <div className="flex-1">
        <h1 className="text-h6 font-bold font-display mb-3">
          {authenticationError && 'Oh nee, er is iets fout gegaan!'}
          {permissionError && 'Oh nee, je hebt nog geen toestemming!'}
        </h1>

        <p className="mb-10">
          {authenticationError && 'Probeer het zometeen even opnieuw.'}
          {permissionError && 'Neem contact op met de beheerder om toestemming tot deze pagina te krijgen.'}
        </p>

        <hr className="w-6/12 mx-auto my-10 border-theme-500 border-opacity-40" />

        {authenticationError && ([
          <h3 className="text-lg font-bold font-display mb-3">Blijft dit scherm terugkomen?</h3>,
          <p className="mb-2">
            Op
            {' '}
            <a
              className={`bg-theme-500 bg-opacity-10 px-2 py-1 rounded-md font-bold
            text-theme-700 hover:bg-opacity-20 transition`}
              href="https://status.infowijs.nl"
              target="_blank"
              rel="noopener noreferrer"
            >
              status.infowijs.nl
            </a>
            {' '}
            kun je zien of wij al op de hoogte zijn van dit probleem.
            <br />
            Staat het probleem er nog niet vermeld, laat het ons zeker even weten!
          </p>,
        ])}

        <div className="hidden">
          {authenticationError}
        </div>

      </div>
    </div>
  )
}

ErrorScreen.propTypes = {
  authenticationError: PropTypes.string,
  permissionError: PropTypes.bool,
}

ErrorScreen.defaultProps = {
  authenticationError: null,
  permissionError: false,
}

export default ErrorScreen
